var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("emd-tabbar", {
        attrs: {
          bordered: true,
          items: _vm.tabbarItems,
          activeItem: _vm.activeItem,
        },
        on: { changed: _vm.goToRoute },
      }),
      _vm.loadingDetail
        ? _c(
            "div",
            {
              staticClass:
                "eu-display_flex eu-align-items_center_md eu-justify_center eu-pa_6",
              staticStyle: { height: "250px" },
            },
            [_c("emd-loader", { attrs: { type: "_subtle" } })],
            1
          )
        : _c(
            "div",
            [
              _vm.activeItem === "recipientsDetail"
                ? _c("Resume", {
                    attrs: {
                      info: _vm.info,
                      bankDetail: _vm.bankDetail,
                      anticipationSettings: _vm.anticipationSettings,
                      transferSettings: _vm.transferSettings,
                      id: _vm.recipientId,
                      status: _vm.kycStatus,
                    },
                  })
                : _vm._e(),
              _vm.activeItem === "recipientsData"
                ? _c("RecipientData", {
                    attrs: {
                      recipient: _vm.recipient,
                      canSearchZipCode: false,
                      default_bank_account: _vm.default_bank_account,
                      isCpf: _vm.isCpf,
                      locks: _vm.locks,
                      recipientDetail: _vm.recipientDetail,
                      canEditRegisterInformation:
                        _vm.canEditRegisterInformation,
                      isKyc: _vm.isKyc,
                    },
                    on: {
                      updated: function ($event) {
                        return _vm.getDetail({ silent: true })
                      },
                    },
                  })
                : _vm._e(),
              _vm.activeItem === "recipientsSettings"
                ? _c("Settings", {
                    attrs: {
                      default_bank_account: _vm.default_bank_account,
                      automatic_anticipation_settings:
                        _vm.automatic_anticipation_settings,
                      transfer_settings: _vm.transfer_settings,
                    },
                  })
                : _vm._e(),
              _vm.activeItem === "recipientsBalance"
                ? _c("recipients-details-balance", {
                    attrs: {
                      recipientIdPgm: _vm.recipientIdPgm,
                      recipientId: _vm.recipientId,
                    },
                  })
                : _vm._e(),
              _vm.activeItem === "recipientsReceivablesRegister"
                ? _c(
                    "div",
                    { staticClass: "el-section" },
                    [_c("dash-receivables-register")],
                    1
                  )
                : _vm._e(),
              _vm.activeItem === "recipientsContracts"
                ? _c(
                    "div",
                    { staticClass: "el-section" },
                    [_c("dash-contracts")],
                    1
                  )
                : _vm._e(),
              _vm.activeItem === "recipientsTransfers"
                ? _c("recipients-details-transfers", {
                    attrs: {
                      recipientIdPgm: _vm.recipientIdPgm,
                      recipientId: _vm.recipientId,
                    },
                  })
                : _vm._e(),
              _vm.activeItem === "recipientsSettlements"
                ? _c(
                    "div",
                    { staticClass: "el-section" },
                    [_c("recipient-details-settlements")],
                    1
                  )
                : _vm._e(),
              _vm.activeItem === "recipientsAnticipations"
                ? _c(
                    "div",
                    { staticClass: "el-section" },
                    [_c("anticipation-list")],
                    1
                  )
                : _vm._e(),
              _vm.activeItem === "recipientsAnticipationDetails"
                ? _c(
                    "div",
                    { staticClass: "el-section" },
                    [_c("anticipation-details")],
                    1
                  )
                : _vm._e(),
              _vm.activeItem === "recipientsAnticipation"
                ? _c(
                    "div",
                    { staticClass: "el-section" },
                    [_c("anticipation-request")],
                    1
                  )
                : _vm._e(),
              _vm.activeItem === "recipientsEarningStatements"
                ? _c(
                    "div",
                    { staticClass: "el-section" },
                    [
                      _c("earning-statements", {
                        attrs: {
                          recipientIdPgm: _vm.recipientIdPgm,
                          recipientId: _vm.recipientId,
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }